import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=7a677eb0&scoped=true"
import script from "./ServiceView.vue?vue&type=script&lang=js"
export * from "./ServiceView.vue?vue&type=script&lang=js"
import style0 from "./ServiceView.vue?vue&type=style&index=0&id=7a677eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a677eb0",
  null
  
)

export default component.exports